import React, { CSSProperties, useEffect, useState } from "react";
import { api, CompanyEmployeeRoleDto, CompanyRolePermission } from "shared/api";
import { useApiMethod } from "shared/lib";
import { Button, Entity, EntityForm, Error, Icons } from "shared/ui";
import styles from "./role-entity.module.scss";
import { RolePermissions } from "./role-permissions";

export interface IRoleEntity {
  data: CompanyEmployeeRoleDto;
  companySlug: string;
  onUpdated: () => void;

  readOnly?: boolean;
  menuItems?: React.ReactNode;
  initialOpen?: boolean;
  // children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const RoleEntity = (props: IRoleEntity) => {
  const [open, setOpen] = useState(props.initialOpen || false);

  const [permissions, setPermissions] = useState<Set<CompanyRolePermission>>(() => new Set(props.data.permissions));
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    setPermissions(new Set(props.data.permissions));
    setTouched(false);
  }, [props.data.permissions]);

  const onChangePermissions = (value: Set<CompanyRolePermission>) => {
    setTouched(true);
    setPermissions(value);
  };

  const submit = useApiMethod(api.companyRbac.companyEmployeeRoleChangePermissions);

  const onSubmit = async () => {
    await submit.call(props.companySlug, props.data.id, { permissions: Array.from(permissions) });
    await props.onUpdated();
    setTouched(false);
  };

  return (
    <>
      <Entity menuItems={props.menuItems}>
        <div
          className={styles.opener}
          onClick={(e) => {
            e.stopPropagation();
            setOpen((it) => !it);
          }}
        >
          <Icons.Down />
        </div>
        <Entity.Field title={props.data.name}></Entity.Field>
        {props.data.type === "DEFAULT" && <Entity.Field description="По умолчанию" right />}
      </Entity>
      {open && (
        <EntityForm
          footerNote={submit.error && <Error label={null}>{submit.error.message}</Error>}
          disabled={props.readOnly}
          primaryAction={
            <Button size="small" disabled={!touched || props.data.type !== "COMMON"} onClick={onSubmit}>
              Сохранить
            </Button>
          }
        >
          <RolePermissions value={permissions} onChange={onChangePermissions} readOnly={props.data.type !== "COMMON"} />
        </EntityForm>
      )}
    </>
  );
};

RoleEntity.defaultProps = {};
